import { FileWrapper } from '../types/types'
import SelectedFileItem from './FileItem'
import { Text } from '@bbl-digital/snorre-v2'

type Props = {
  files: FileWrapper[]
}

const PickerFileList = ({ files }: Props) => {
  if (!files || files.length === 0) return null

  return (
    <div>
      <Text className="font-semibold mb-1">Filnavn</Text>
      {files.map((file) => (
        <SelectedFileItem key={file.id} file={file} />
      ))}
    </div>
  )
}

export default PickerFileList
